/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Trip } from './Trip';
import {
    TripFromJSON,
    TripFromJSONTyped,
    TripToJSON,
    TripToJSONTyped,
} from './Trip';

/**
 * 
 * @export
 * @interface Trips
 */
export interface Trips {
    /**
     * 
     * @type {Array<Trip>}
     * @memberof Trips
     */
    items?: Array<Trip>;
}

/**
 * Check if a given object implements the Trips interface.
 */
export function instanceOfTrips(value: object): value is Trips {
    return true;
}

export function TripsFromJSON(json: any): Trips {
    return TripsFromJSONTyped(json, false);
}

export function TripsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Trips {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(TripFromJSON)),
    };
}

export function TripsToJSON(json: any): Trips {
    return TripsToJSONTyped(json, false);
}

export function TripsToJSONTyped(value?: Trips | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(TripToJSON)),
    };
}

